import { ServerSentEventService } from '@/api/server-sent-event.service';
import type { ProcessSessionEventDto } from '@carvia/ros-client-types';

export function processSessionEventsService(bookingId: string) {
  return new ServerSentEventService<ProcessSessionEventDto>(
    `/bookings/${bookingId}/process-session/events`,
  );
}

export function counterProcessSessionEventsService(counterId: string) {
  return new ServerSentEventService<ProcessSessionEventDto>(
    `/counters/${counterId}/process-session/events`,
  );
}
